import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ObjectResultDto } from '../models/ObjectResult';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EntryPoints } from '../entrypoints';
import {sprintf} from 'sprintf-js';
import * as signalR from '@aspnet/signalr';
import { AuthenticationService } from './auth.service';
import { MessagesService } from './messages.service';
import { InternalMessage } from '../models/internal.message';
import Actions from '../constants/actions';

@Injectable({
  providedIn: 'root'
})
export class RecordsService extends EntryPoints {

  
  private hubConnection: signalR.HubConnection;

  constructor(private httpClient: HttpClient, private authenticationService: AuthenticationService, private messagesService: MessagesService) { 
    super();
  }

  getCurrentReadings(scales:string): Observable<ObjectResultDto> {
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getCurrentReadingsUrl, scales));
  }



  getLastStatus(plant_id: number) : Observable<ObjectResultDto> {
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getLastStatusUrl, plant_id));
  }
  
  getProductionAnalytics(plant_id: number) : Observable<ObjectResultDto> {
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getProductionAnalyticsUrl, plant_id));
  }

  getAllProductionAnalytics() : Observable<ObjectResultDto>{
    return this.httpClient.get<ObjectResultDto>(this.getAllProductionAnalyticsUrl);
  }

  getTruckFeed(plant_id: number): Observable<ObjectResultDto>{
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getTruckFeedUrl, plant_id));
  }

  getCurrentShelf(plant_id: number) : Observable<ObjectResultDto>{
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getCurrentShelfUrl, plant_id));
  }

  getLivePoints(scale_ids: string, minutes: number) {
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getLivePointsUrl, scale_ids, minutes));        
  }

  GetDailyTotalsByScale(scales: string, startDateVal: string, endDateVal: string) {
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getDailyTotalsByScaleUrl, scales, startDateVal, endDateVal));
  }

  getPercentages(inputScales: string, outputScales: string, startDate: string, endDate: string) {
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getPercentagesByScaleUrl, inputScales, outputScales, startDate, endDate));
  }


  getDailyTotalsByProduct(product_id: string, startDate: string, endDate: string){
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getDailyTotalsByProductUrl, product_id, startDate, endDate));
  }

  getDailyTotalsByScaleAndShift(scales: string, plantShift_id: number, startDateVal: string, endDateVal: string) {
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getDailyTotalsByScaleAndShiftUrl, scales, plantShift_id, startDateVal, endDateVal));
  }

  getDailyTotalsByProductAndShift(product_id: string, plantShift_id: number, startDateVal: string, endDateVal: string){
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getDailyTotalsByProductAndShiftUrl, product_id, plantShift_id, startDateVal, endDateVal));
  }

  getLinesPoints(scales: string, date: string) {
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getLinePointsUrl, scales, date));
  }

  getLineSpeedPoints(scales: string, date: string) {
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getLineSpeedPointsUrl, scales, date));
  }

  getLineConsumptionPoints(plant_id: number, date: string){
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getLineConsumptionPointsUrl, plant_id, date));
  }

  getDailyTotalReport(scale: number, startDateString: string, endDateString: string) : Observable<ObjectResultDto>{
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getDailyTotalReportUrl, scale, startDateString, endDateString));  
  }

  getWeeklyReport(scale: number, startDateString: string, endDateString: string) : Observable<ObjectResultDto>{
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getWeeklyReportUrl, scale, startDateString, endDateString));  
  }  

  getRecordHistory(scale: string, start: string, end: string) : Observable<ObjectResultDto>{
    return this.httpClient.get<ObjectResultDto>(sprintf(this.getRecordHistoryUrl, scale, start, end));  
  }  

  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
                          .withUrl(this.listenDashboardMessagesUrl,
                          {
                            accessTokenFactory: () => this.authenticationService.currentUser().access_token,
                           skipNegotiation: true,
                           transport: signalR.HttpTransportType.WebSockets
                          })
                          .build();
    this.hubConnection
        .start()
        .then(() => {})
        .catch(err => { });

    this.hubConnection.on('NewRecordReceived', (scale_id, weight, tph,record_minute ) => {
      let newMessage = new InternalMessage();
      newMessage.action = Actions.newRecord;
      newMessage.parameters = {'scale_id': scale_id, 'weight': weight,'tph': tph, 'minute': record_minute*1000};
      this.messagesService.sendMessage(newMessage);
    });

    this.hubConnection.on('NewStatusReceived', (plant_id) => {
      let newMessage = new InternalMessage();
      newMessage.action = Actions.newStatus;
      newMessage.parameters = {'plant_id': plant_id};
      this.messagesService.sendMessage(newMessage);
    });

    this.hubConnection.on("NewTruckFeedReceived", (plant_id)=>{
      let newMessage = new InternalMessage();
      newMessage.action = Actions.newTruckFeed;
      newMessage.parameters = {'plant_id': plant_id};
      this.messagesService.sendMessage(newMessage);
    });

    this.hubConnection.on('UpdateMainReceived', (plant_id) => {
      let newMessage = new InternalMessage();
      newMessage.action = Actions.updateMain;
      newMessage.parameters = {'plant_id': plant_id};
      this.messagesService.sendMessage(newMessage);
    });

    this.hubConnection.on('NewInputReceived', (plant_id, input_id, value, hour, date) => {
      let newMessage = new InternalMessage();
      newMessage.action = Actions.newInput;
      newMessage.parameters = {'plant_id': plant_id, 'input_id':input_id, 'value':value,'reading_date': date + ', ' + hour};
      this.messagesService.sendMessage(newMessage);
    });   
    
    this.hubConnection.on('NewNotificationReceived', (count) => {
      debugger
      let newMessage = new InternalMessage();
      newMessage.action = Actions.newnotification;
      newMessage.parameters = {'count': count};
      this.messagesService.sendMessage(newMessage);
    });   
  }

  public endConnection = () => {
    if(this.hubConnection != undefined)
    {
      this.hubConnection.stop();
    }
  }
}
